import React from 'react';
import VendorServiceSkeleton from './VendorServiceSkeleton';

/**
 * Reusable skeleton loader for category service sections
 * Shows multiple skeleton sections to simulate loading categories
 * 
 * @param {number} sections - Number of category sections to show (default: 2)
 * @param {number} servicesPerSection - Number of service cards per section (default: 6)
 * @param {string} className - Additional CSS classes for the container
 * @param {boolean} showHeader - Whether to show the section header skeleton (default: true)
 * @param {object} serviceCardProps - Props to pass to VendorServiceSkeleton
 */
const CategoryServicesSkeleton = ({ 
  sections = 2, 
  servicesPerSection = 6,
  className = '',
  showHeader = true,
  serviceCardProps = {}
}) => {
  return (
    <div className={className}>
      {Array.from({ length: sections }).map((_, index) => (
        <section
          key={index}
          className={`py-8 bg-white relative overflow-hidden ${index % 2 === 1 ? 'bg-gray-50' : ''}`}
        >
          <div className="page-container relative z-10">
            {/* Section Header Skeleton */}
            {showHeader && (
              <div className="flex items-center justify-between mb-6">
                <div className="h-6 bg-gray-200 rounded w-48 animate-pulse">
                  <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_infinite]" />
                </div>
              </div>
            )}

            {/* Services Skeleton */}
            <VendorServiceSkeleton count={servicesPerSection} {...serviceCardProps} />
          </div>
        </section>
      ))}
    </div>
  );
};

export default CategoryServicesSkeleton;

